import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type GraphResponse } from '../../api/knowledge';

export function KnowledgeGraphViewerPage() {
  const [graph, setGraph] = useState<GraphResponse | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void knowledgeApi.graph().then(setGraph).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-5xl p-6">
      <Link to="/knowledge" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Knowledge Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Knowledge Graph Viewer</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {graph && (
        <>
          <p className="mt-2 text-sm text-slate-500">{graph.node_count} nodes · {graph.edge_count} edges</p>
          <div className="mt-6 overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left dark:border-slate-700">
                  <th className="p-2">Name</th>
                  <th className="p-2">Type</th>
                  <th className="p-2">Source</th>
                  <th className="p-2">Confidence</th>
                </tr>
              </thead>
              <tbody>
                {graph.nodes.map((n) => (
                  <tr key={n.id} className="border-b dark:border-slate-800">
                    <td className="p-2 font-medium">{n.name}</td>
                    <td className="p-2">{n.type}</td>
                    <td className="p-2">{n.source}</td>
                    <td className="p-2">{(n.confidence * 100).toFixed(0)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-6 rounded-lg border p-4 dark:border-slate-700">
            <h2 className="font-medium">Relationships</h2>
            <ul className="mt-2 space-y-1 text-xs text-slate-600 dark:text-slate-400">
              {graph.relationships.map((r) => (
                <li key={r.id}>{r.from_node_id} → {r.to_node_id} ({r.type})</li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
